import { map, size, words } from 'lodash'

const acronym = (value) =>
{
	const array = words(value)

	if ( !size(array) )
	{
		return value
	}

	return map(array, word => word.charAt(0).toUpperCase()).join('')
}

export default acronym